import gql from 'graphql-tag'

const query = gql`
query listBillsItems($id: ID!) {
	cashAssist {
		getBill(id: $id) {
			items {
	      id
	      price
	      total
	      amount
	      codeMWSt
	      discountPercent
	      flag
	      mul1
	      product {
	          name
	      }
	      inCafe
      }
		}
	}
}`

export default query
